export const scaleCSSUnit = (value: string, zoomFactor: number) => {
  try {
    if (!value) return value;

    const match = value.match(/^([0-9.]+)([a-z%]+)$/i);

    if (!match) {
      return value;
    }

    const originalValue = parseFloat(match[1]);
    const unit = match[2];

    const scaledValue = originalValue / (zoomFactor / 100);

    return `${scaledValue}${unit}`;
  } catch (error) {
    console.warn(error);

    return value;
  }
};
